"use strict";
/*
 * Created on 13. 3. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var index_1 = require("./index");
/**
 * Cache capable of asynchronous reading of stored values.
 * @author Stepan Mik
 */


var AsyncCache =
/*#__PURE__*/
function () {
  function AsyncCache(name, provider, logger) {
    _classCallCheck(this, AsyncCache);

    this.name = name;
    this.provider = provider;
    this.logger = logger;
    this.missing = new Set();
    this.values = new Map();
    this.warning = new Set();
    /**/
  }
  /**
   * Determines if value for key was already loaded
   * @param key
   */


  _createClass(AsyncCache, [{
    key: "has",
    value: function has(key) {
      return this.values.has(key);
    }
    /**
     * Forces preloading elements into cache.
     * @param keys list of keys to be loaded
     * @returns number of keys loaded or already present (guaranteed to be in cache), if the number is lesser
     *     than number of provided keys, not all keys can be loaded
     */

  }, {
    key: "preload",
    value: function () {
      var _preload = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _len,
            args,
            _key,
            keys,
            data,
            toLoad,
            loaded,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            k,
            toLoadSet,
            material,
            _iteratorNormalCompletion2,
            _didIteratorError2,
            _iteratorError2,
            _iterator2,
            _step2,
            d,
            _iteratorNormalCompletion3,
            _didIteratorError3,
            _iteratorError3,
            _iterator3,
            _step3,
            m,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                keys = args[0], data = args[1];

                if (!keys.isEmpty()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", 0);

              case 4:
                toLoad = [];
                loaded = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;

                for (_iterator = keys.values()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  k = _step.value;

                  if (this.values.has(k)) {
                    loaded++;
                  } else {
                    if (!this.missing.has(k)) {
                      toLoad.push(k);
                    }
                  }
                }

                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 17:
                _context.prev = 17;
                _context.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 20:
                _context.prev = 20;

                if (!_didIteratorError) {
                  _context.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context.finish(20);

              case 24:
                return _context.finish(17);

              case 25:
                if (!(toLoad.length === 0)) {
                  _context.next = 27;
                  break;
                }

                return _context.abrupt("return", loaded);

              case 27:
                toLoadSet = new Set(toLoad);
                _context.next = 30;
                return this.provider(toLoad, data);

              case 30:
                material = _context.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 34;

                for (_iterator2 = material[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  d = _step2.value;
                  loaded++;
                  this.values.set(d.id, d);
                  toLoadSet.delete(d.id);
                }

                _context.next = 42;
                break;

              case 38:
                _context.prev = 38;
                _context.t1 = _context["catch"](34);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 42:
                _context.prev = 42;
                _context.prev = 43;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 45:
                _context.prev = 45;

                if (!_didIteratorError2) {
                  _context.next = 48;
                  break;
                }

                throw _iteratorError2;

              case 48:
                return _context.finish(45);

              case 49:
                return _context.finish(42);

              case 50:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context.prev = 53;

                for (_iterator3 = toLoadSet[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  m = _step3.value;
                  this.missing.add(m);
                }

                _context.next = 61;
                break;

              case 57:
                _context.prev = 57;
                _context.t2 = _context["catch"](53);
                _didIteratorError3 = true;
                _iteratorError3 = _context.t2;

              case 61:
                _context.prev = 61;
                _context.prev = 62;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 64:
                _context.prev = 64;

                if (!_didIteratorError3) {
                  _context.next = 67;
                  break;
                }

                throw _iteratorError3;

              case 67:
                return _context.finish(64);

              case 68:
                return _context.finish(61);

              case 69:
                return _context.abrupt("return", loaded);

              case 70:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 13, 17, 25], [18,, 20, 24], [34, 38, 42, 50], [43,, 45, 49], [53, 57, 61, 69], [62,, 64, 68]]);
      }));

      return function preload() {
        return _preload.apply(this, arguments);
      };
    }()
  }, {
    key: "set",
    value: function set(value) {
      this.missing.delete(value.id);
      this.values.set(value.id, value);
    }
    /**
     * Determines if given ID was detected as missing during previous attempts to load entity into cache.
     */

  }, {
    key: "isMissing",
    value: function isMissing(id) {
      return this.missing.has(id);
    }
  }, {
    key: "get",

    /**
     * Retrieves value for given key (if value for the key was already loaded)
     * @param key
     * @param defVal
     */
    value: function get(key, defVal) {
      var ret = this.values.get(key);

      if (ret !== undefined) {
        return ret;
      }

      this.logMissing(key);
      return defVal;
    }
    /**
     * Retrieves value for given key (if value for the key was already loaded) or throw an exception.
     * @param key
     */

  }, {
    key: "getStrict",
    value: function getStrict(key) {
      return this.values.get(key) || index_1.Utils.fail(this.name + ': item not in cache: ' + key);
    }
  }, {
    key: "logMissing",
    value: function logMissing(key) {
      if (this.logger && !this.warning.has(key)) {
        this.logger('Missing ' + this.name + ' value for key ' + key);
        this.warning.add(key);
      }
    }
    /**
     * Retrieves value for given key (if value for the key was already loaded)
     * @param key
     * @param defVal
     */

  }, {
    key: "getOrLoad",
    value: function () {
      var _getOrLoad = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _len2,
            args,
            _key2,
            key,
            defVal,
            data,
            ret,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args2[_key2];
                }

                key = args[0], defVal = args[1], data = args[2];

                if (!this.missing.has(key)) {
                  _context2.next = 5;
                  break;
                }

                this.logMissing(key);
                return _context2.abrupt("return", defVal);

              case 5:
                ret = this.values.get(key);

                if (!(ret !== undefined)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", ret);

              case 8:
                _context2.next = 10;
                return this.preload.apply(this, [immutable_1.List.of(key), data]);

              case 10:
                return _context2.abrupt("return", this.getOrLoad.apply(this, args));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function getOrLoad() {
        return _getOrLoad.apply(this, arguments);
      };
    }()
    /**
     * Retrieves values for given keys. First tries to preload values and then returns list of
     * values that correspond to provided keys. Missing values are omitted from resulting list.
     * @param keys
     * @param data
     */

  }, {
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _len3,
            args,
            _key3,
            ids,
            data,
            ret,
            _iteratorNormalCompletion4,
            _didIteratorError4,
            _iteratorError4,
            _iterator4,
            _step4,
            id,
            v,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (_len3 = _args3.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  args[_key3] = _args3[_key3];
                }

                ids = args[0], data = args[1];
                _context3.next = 4;
                return this.preload.apply(this, args);

              case 4:
                ret = [];
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context3.prev = 8;

                for (_iterator4 = ids.values()[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  id = _step4.value;
                  v = this.values.get(id);

                  if (v !== undefined) {
                    ret.push(v);
                  }
                }

                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](8);
                _didIteratorError4 = true;
                _iteratorError4 = _context3.t0;

              case 16:
                _context3.prev = 16;
                _context3.prev = 17;

                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }

              case 19:
                _context3.prev = 19;

                if (!_didIteratorError4) {
                  _context3.next = 22;
                  break;
                }

                throw _iteratorError4;

              case 22:
                return _context3.finish(19);

              case 23:
                return _context3.finish(16);

              case 24:
                return _context3.abrupt("return", immutable_1.List(ret));

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 12, 16, 24], [17,, 19, 23]]);
      }));

      return function getMany() {
        return _getMany.apply(this, arguments);
      };
    }()
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.values[Symbol.iterator]();
    }
  }, {
    key: "clean",
    value: function clean() {
      this.missing = new Set();
      this.values = new Map();
    }
    /**
     * Removes cached value for provided key.
     * @param id id of value to be removed
     */

  }, {
    key: "remove",
    value: function remove(id) {
      this.warning.delete(id);
      this.values.delete(id);
      this.missing.delete(id);
    }
  }, {
    key: "missingCount",
    get: function get() {
      return this.missing.size;
    }
  }]);

  return AsyncCache;
}();

exports.AsyncCache = AsyncCache;